export default __webpack_public_path__ + "a728dfcd2b5be38c8f69f0ea7a5cfa13.svg";